import React from 'react'
import { Viewer, Worker, SpecialZoomLevel } from '@react-pdf-viewer/core'
import '@react-pdf-viewer/core/lib/styles/index.css'
import { version as pdfjsVersion } from 'pdfjs-dist'
import AdminUserGuide from '../../assets/pdf/AdminUserGuide.pdf'
import TeamMemberUserGuide from '../../assets/pdf/TeamMemberUserGuide.pdf'

interface UserGuideProps {
  role: string
}

const UserGuide: React.FC<UserGuideProps> = ({ role = 'teamMember' }) => {
  return (
    <Worker workerUrl={`//unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.js`}>
      <div style={{ height: 'auto', overflow: 'auto' }}>
        <Viewer
          fileUrl={role === 'admin' ? AdminUserGuide : TeamMemberUserGuide}
          defaultScale={SpecialZoomLevel.PageWidth}
        />
      </div>
    </Worker>
  )
}

export default UserGuide
